// Route guards. RequireAuth redirects to /login; RequirePermission renders a Forbidden
// notice when the user lacks the permission (mirrors the server's 403).
import type { PermissionKey } from '@alignova/shared';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext.tsx';
import { LiveAlerts } from '../app/LiveAlerts.tsx';
import { useCan } from './useCan.ts';
import { t } from '../i18n/index.ts';

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid h-full place-items-center text-muted">{t('common.loading')}</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      {/* Chime + toast for anything arriving on the live stream while the app is open. */}
      <LiveAlerts />
      <Outlet />
    </>
  );
}

export function RequirePermission({ permission }: { permission: PermissionKey }) {
  const can = useCan();
  if (!can(permission)) {
    return (
      <div className="grid h-full place-items-center">
        <p className="rounded-lg bg-status-urgent-bg px-4 py-3 text-status-urgent-fg">
          {t('common.forbidden')}
        </p>
      </div>
    );
  }
  return <Outlet />;
}
